import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building, Home } from 'lucide-react';
import RealEstateListingForm from '../../components/p2p/RealEstateListingForm';
import api from '../../utils/api';
import { toast } from 'sonner';

const CreateRealEstateListing = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (formData) => {
    setSubmitting(true);
    try {
      // Add category_id for real estate
      const listingData = {
        ...formData,
        category_id: 'real_estate',  // Will be created if doesn't exist
        subcategory_id: formData.property_type,
        condition: 'new'  // Real estate doesn't have condition
      };

      const response = await api.post('/p2p/listings', listingData);
      
      if (response.data.id) {
        toast.success('Property listed successfully!');
        navigate(`/deals/${response.data.id}`);
      }
    } catch (error) {
      console.error('Submit error:', error);
      const errorMsg = error.response?.data?.detail || 'Failed to create listing';
      toast.error(errorMsg);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary/20 to-purple-500/20 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-muted-foreground hover:text-foreground mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Back
          </button>
          
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-primary/20 rounded-2xl flex items-center justify-center">
              <Building className="w-8 h-8 text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold">List Your Property</h1>
              <p className="text-muted-foreground">
                Create a detailed real estate listing with all property information
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <RealEstateListingForm 
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default CreateRealEstateListing;
